import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/disk/recover.svg';
const Recover = () => React.createElement(IconSvg, null);
export default Recover;
